import React, {useState} from "react";
import ManagementIconButton from "../../../components/actions/ManagementIconButton";
import ManagementActionDetails from "../../../components/actions/ManagementActionDetails";
import {useHistory} from "react-router-dom";
import FormGenerator from "../../../components/form/FormGenerator";
import {fields} from "../../../components/actions/ConsentDetailsFormConfig";
import { useModels } from "../../../helpers/models";
import { useActions } from "../../../helpers/actions";

const ManagementHistoryActions = ({row, id, openInNew}) => {

    const history = useHistory();
    const actions = useActions();
    const models = useModels();

    const [cleaning, setCleaning] = useState();
    const [storage, setStorage] = useState();
    const [consent, setConsent] = useState();


    const handleClickVerification = (versionId) => {
        const currentLocation = history.location.pathname;


        const addedPath = "/verification/history/" + versionId;
        const newLocation = `${currentLocation}${addedPath}`;

        history.push(newLocation);
    };


    function buildIconsByActionType(item) {

        const modelAction = actions.map(a => a.model)
            .find(model => item.actionType === model.actionType)


        return <ManagementIconButton icon={modelAction.icon}
                                     onClick={() => {
                                         if (openInNew) {
                                             window.open(`/#${models.management.url}/${id}/${modelAction.guiUrl || modelAction.url}/${item.details}${modelAction.actionSubtype ? `/` : ``}${modelAction.actionSubtype ? modelAction.actionSubtype : ``}`, "_blank");
                                         } else {
                                             history.push(`${models.management.url}/${id}/${modelAction.guiUrl || modelAction.url}/${item.details}${modelAction.actionSubtype ? `/` : ``}${modelAction.actionSubtype ? modelAction.actionSubtype : ``}`)
                                         }
                                     }}
                                     tooltip={modelAction.title}
        />
    }

    const renderConsent = (details) => {

        return <>
            <FormGenerator
                fields={fields}
                formData={details}
                readOnly
                initData={false}
                setFormData={() => {
                }}
            />
        </>;
    };


    return (
        <>
            {
                row.actions ? row.actions.map(a => {
                        return buildIconsByActionType(a);
                    })

                    : buildIconsByActionType(row)
            }

            {cleaning ?
                <ManagementActionDetails
                    title="Czyszczenie/Suszenie"
                    icon="fa-burn"
                    actionName="cleaning"
                    id={cleaning}
                    setId={setCleaning}/>
                : ""}


            {storage ?
                <ManagementActionDetails
                    title="Przechowywanie"
                    icon="fa-warehouse"
                    actionName="storage"
                    shrink={true}
                    id={storage}
                    setId={setStorage}/>
                : ""}

            {consent ?
                <ManagementActionDetails
                    title="Zgody"
                    icon="fa-check-double"
                    actionName="consent"
                    shrink={true}
                    id={consent}
                    size={"md"}
                    custom={renderConsent}
                    setId={setConsent}/>
                : ""}

            {/*{filterReplace &&*/}
            {/*  <ReplaceFiltersModal*/}
            {/*    open={filterReplace}*/}
            {/*    setLoader={() => {*/}
            {/*    }}*/}
            {/*    setOpen={() => setFilterReplace(undefined)}*/}
            {/*    replaceId={filterReplace}*/}
            {/*    onFinish={() => setFilterReplace(undefined)}*/}
            {/*  />*/}

            {/*}*/}
            {/*<ToolsActionDetails actionId={setFilterReplace} setActionId={setFilterReplace} actionName="withdrawal" />*/}
            {/*<ToolsActionDetails actionId={toolCreationId} setActionId={setToolCreationId} actionName="creation" />*/}
            {/*<RepairActionDetails show={showNewModal} setShow={setShowNewModal} id={repairIdSelected} />*/}
        </>
    );
};

export default ManagementHistoryActions;